export const ENUM_TYPE = {
  shift: 1,
  job_type: 2,
  task_type: 3,
  holiday_type: 4,
  vip_rank: 5,
  audit_case_type: 6,
  report_output_type: 7,
}

export const SHIFT_TYPE = {
  all_day: 1,
  day: 2,
  night: 3,
  afternoon: 4,
}

export const JOB_TYPE_OPTIONS = [
  {
    value: 1,
    label: 'Admin(Input)',
  },
  {
    value: 2,
    label: 'Panel(Output)',
  },
  {
    value: 3,
    label: 'Manager',
  },
  {
    value: 4,
    label: 'Auditor',
  },
  {
    value: 5,
    label: 'Head',
  },
];

export const JOB_TYPE = {
  admin_input: 1,
  panel_output: 2,
  manager: 3,
  auditor: 4,
  head: 5,
  marketing: 6,
};

/** Job types that receive auto case assignment */
export const CASE_ASSIGNMENT_JOB_TYPES = [JOB_TYPE.panel_output];

export const USER_ROLE = {
  super_admin: 1,
  admin: 2,
  employee: 3,
}

export const JOB_TYPE_MAPPING = {
  1: 'Admin(Input)',
  2: 'Panel(Output)',
  3: 'Manager',
  4: 'Auditor',
  5: 'Head',
  6: 'Marketing',
};

export const USER_ROLE_OPTIONS = [
  {
    value: 1,
    label: 'Owner',
  },
  {
    value: 2,
    label: 'Super Admin',
  },
];

export const USER_ROLE_MAPPING = {
  1: 'Owner',
  2: 'Super Admin',
};

export const SHIFT_OPTIONS = [
  {
    value: 1,
    label: 'All Day',
  },
  {
    value: 2,
    label: 'Day(8.00 - 20.00)',
  },
  {
    value: 3,
    label: 'Night(20.00 - 08.00)',
  },
  {
    value: 4,
    label: 'Afternoon(14.00 - 02.00)',
  },
];

export const SHIFT_MAPPING = {
  1: 'All Day',
  2: 'Day(8.00 - 20.00)',
  3: 'Night(20.00 - 08.00)',
  4: 'Afternoon(14.00 - 02.00)',
};

export const CUSTOMFIELD_TYPE_OPTIONS = [
  {
    value: 1,
    label: 'Text',
  },
  {
    value: 2,
    label: 'Number',
  },
  {
    value: 3,
    label: 'Date',
  },
  {
    value: 4,
    label: 'Select',
  },
  {
    value: 5,
    label: 'Textarea',
  },
  {
    value: 6,
    label: 'Image',
  },
  {
    value: 7,
    label: 'เช็คโปรวันเกิด',
  },
];

// key → value ของ customfield.type (เลี่ยงการเทียบด้วย label ที่เปลี่ยนได้)
export const CUSTOMFIELD_TYPE = {
  text: 1,
  number: 2,
  date: 3,
  select: 4,
  textarea: 5,
  image: 6,
  birthday_promo: 7,
};

// type ที่ผูกกับระบบเฉพาะบริษัท ดูที่ src/data/companyFeatures.js (CUSTOMFIELD_TYPE_FEATURE)

// โหมดรูปสำหรับ customfield type=Image
export const CUSTOMFIELD_IMAGE_MODE_OPTIONS = [
  { value: 0, label: 'รูปเดียว (Single)' },
  { value: 1, label: 'หลายรูป (Multiple)' },
];

export const CUSTOMFIELD_TYPE_MAPPING = {
  1: 'Text',
  2: 'Number',
  3: 'Date',
  4: 'Select',
  5: 'Textarea',
  6: 'Image',
  7: 'เช็คโปรวันเกิด',
};

// Task Type Options - หน้าที่ของพนักงาน (Dashboard switches / Admin Employees)
export const REGISTER_TASK = 'Register';

export const TASK_TYPE_OPTIONS = [
  { value: 'Deposit', label: 'Deposit' },
  { value: 'Withdraw', label: 'Withdraw' },
  { value: 'ETC', label: 'ETC' },
  { value: REGISTER_TASK, label: 'Register' },
];

export const TASK_TYPE_MAPPING = {
  Deposit: 'Deposit',
  Withdraw: 'Withdraw',
  ETC: 'ETC',
  Register: 'Register',
};

/** Inputs.caseName values for ส่งเคส (Input page) */
export const INPUT_CASE_TYPE_OPTIONS = [
  { value: 'deposit', label: 'Deposit' },
  { value: 'withdraw', label: 'Withdraw' },
  { value: 'ETC', label: 'ETC' },
  { value: 'Panel', label: 'Panel' },
  { value: REGISTER_TASK, label: 'Register' },
];

/** caseName values that require receipt image on Input form */
export const INPUT_CASE_REQUIRES_IMAGE = ['deposit'];

/** Inputs.caseName → CaseTopic.type (dataManage.case1) for Case page */
export const INPUT_CASE_TO_CASE1 = {
  deposit: '1',
  withdraw: '2',
  ETC: '3',
  Panel: '4',
  [REGISTER_TASK]: '5',
};

export const CASE1_TYPE_LABELS = {
  1: 'Deposit',
  2: 'Withdraw',
  3: 'ETC.',
  4: 'Panel',
  5: 'Register',
};

// Holiday Type Options - ประเภทวันหยุด (รองรับการเพิ่มทีหลัง)
export const HOLIDAY_TYPE_OPTIONS = [
  { value: 'dayoff', label: 'วันหยุด' },
  { value: 'work', label: 'ทำงานปกติ (ลบวันหยุด)' },
];

export const HOLIDAY_TYPE_MAPPING = {
  'dayoff': 'วันหยุด',
  'work': 'ทำงานปกติ',
};

